import type { OapPaymentPlan } from '@/types'

export const inmanOapPaymentOptions: OapPaymentPlan[] = [
	{
		id: 'precoa-individual-single',
		title: 'INDIVIDUAL_PLAN',
		price: 499,
		pricePointId: 'PRECOA',
		paymentCount: 1,
	},
	{
		id: 'precoa-individual-3mo',
		title: 'INDIVIDUAL_PLAN',
		price: 166.33,
		pricePointId: 'PRECOA',
		paymentCount: 3,
	},
	{
		id: 'precoa-individual-12mo',
		title: 'INDIVIDUAL_PLAN',
		price: 50,
		pricePointId: 'PRECOA',
		paymentCount: 12,
	},
	{
		id: 'forestlawn-individual-single',
		title: 'INDIVIDUAL_PLAN',
		price: 499,
		pricePointId: 'FORESTLAWN',
		paymentCount: 1,
	},
	{
		id: 'forestlawn-individual-3mo',
		title: 'INDIVIDUAL_PLAN',
		price: 166.33,
		pricePointId: 'FORESTLAWN',
		paymentCount: 3,
	},
	{
		id: 'forestlawn-individual-12mo',
		title: 'INDIVIDUAL_PLAN',
		price: 50,
		pricePointId: 'FORESTLAWN',
		paymentCount: 12,
	},
	{
		id: 'porterloring-individual-single',
		title: 'INDIVIDUAL_PLAN',
		price: 499,
		pricePointId: 'PORTER-LORING',
		paymentCount: 1,
	},
	{
		id: 'porterloring-individual-3mo',
		title: 'INDIVIDUAL_PLAN',
		price: 166.33,
		pricePointId: 'PORTER-LORING',
		paymentCount: 3,
	},
	{
		id: 'porterloring-individual-12mo',
		title: 'INDIVIDUAL_PLAN',
		price: 50,
		pricePointId: 'PORTER-LORING',
		paymentCount: 12,
	},
	{
		id: 'prerp-individual-single',
		title: 'INDIVIDUAL_PLAN',
		price: 549,
		pricePointId: 'PRERP',
		paymentCount: 1,
	},
	{
		id: 'prerp-individual-3mo',
		title: 'INDIVIDUAL_PLAN',
		price: 183,
		pricePointId: 'PRERP',
		paymentCount: 3,
	},
	{
		id: 'prerp-individual-12mo',
		title: 'INDIVIDUAL_PLAN',
		price: 55,
		pricePointId: 'PRERP',
		paymentCount: 12,
	},
]
